import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-awesome-check",
  "use": "icon-awesome-check-usage",
  "viewBox": "0 0 31.495 23.486",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.495 23.486\" id=\"icon-awesome-check\"><defs><style>#icon-awesome-check .a{fill:#1db78b;}</style></defs><path class=\"a\" d=\"M10.7,27.6.461,17.366a1.575,1.575,0,0,1,0-2.227l2.227-2.227a1.575,1.575,0,0,1,2.227,0l6.9,6.9L26.579,5.038a1.575,1.575,0,0,1,2.227,0l2.227,2.227a1.575,1.575,0,0,1,0,2.227L12.924,27.6A1.575,1.575,0,0,1,10.7,27.6Z\" transform=\"translate(0 -4.577)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol